import { Button, Stack } from '@mui/material'
import React from 'react'
import { BusMgtImg } from '../../Assets/svgs'
import AddOutlinedIcon from "@mui/icons-material/AddOutlined";

const CreateUI = ({ handleOpen }) => {
    return (
        <React.Fragment>
            <Stack alignItems={"center"}>
                <BusMgtImg />
            </Stack>
            <Stack alignItems={"center"}>
                <Button onClick={handleOpen} variant='contained' startIcon={<AddOutlinedIcon />} color='primary' sx={{ textTransform: 'capitalize', borderRadius: '8px', padding: "15px 40px" }}>
                    Create Business
                </Button>
            </Stack></React.Fragment>
    )
}

export default CreateUI